import { Component } from '@theme/component';
import { VariantSelectedEvent } from '@theme/events';
import { requestYieldCallback, getViewParameterValue } from '@theme/utilities';

export default class VariantPicker extends Component {
  #pendingRequestUrl;
  #abortController;

  #hydrated = false;

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('change', this.variantChanged.bind(this));

    requestAnimationFrame(() => {
      this.#hydrated = true;
    });
  }

  // =========================
  // VARIANT CHANGE
  // =========================

  variantChanged(event) {
    if (!(event.target instanceof HTMLElement)) return;

    const selectedOption =
      event.target instanceof HTMLSelectElement
        ? event.target.options[event.target.selectedIndex]
        : event.target;

    if (!selectedOption) return;

    this.updateSelectedOption(event.target);

    this.dispatchEvent(
      new VariantSelectedEvent({
        id: selectedOption.dataset.optionValueId ?? '',
      })
    );

    if (!this.#hydrated) return;

    const isOnProductPage =
      this.dataset.templateProductMatch === 'true' &&
      !event.target.closest('product-card') &&
      !event.target.closest('quick-add-dialog');

    const currentUrl = this.dataset.productUrl?.split('?')[0];
    const newUrl = selectedOption.dataset.connectedProductUrl;

    const loadsNewProduct =
      isOnProductPage && !!newUrl && newUrl !== currentUrl;

    this.fetchUpdatedSection(
      this.buildRequestUrl(selectedOption),
      loadsNewProduct
    );

    const url = new URL(window.location.href);
    const variantId = selectedOption.dataset.variantId || null;

    if (isOnProductPage) {
      if (variantId) url.searchParams.set('variant', variantId);
      else url.searchParams.delete('variant');
    }

    if (loadsNewProduct) url.pathname = newUrl;

    if (url.href !== window.location.href) {
      requestYieldCallback(() => {
        history.replaceState({}, '', url.toString());
      });
    }
  }

  // =========================
  // UPDATE UI (FIX CORE BUG HERE)
  // =========================

  updateSelectedOption(target) {
    if (target instanceof HTMLInputElement) {
      target.checked = true;
    }

    if (target instanceof HTMLSelectElement) {
      const opt = target.options[target.selectedIndex];
      if (!opt) return;

      for (const o of target.options) o.removeAttribute('selected');
      opt.setAttribute('selected', 'selected');
    }
  }

  buildRequestUrl(selectedOption) {
    let productUrl =
      selectedOption.dataset.connectedProductUrl ||
      this.#pendingRequestUrl ||
      this.dataset.productUrl;

    this.#pendingRequestUrl = productUrl;

    const params = [];
    const view = getViewParameterValue();

    if (view) params.push(`view=${view}`);

    if (this.selectedOptionsValues.length) {
      params.push(`option_values=${this.selectedOptionsValues.join(',')}`);
    }

    return `${productUrl}?${params.join('&')}`;
  }

  fetchUpdatedSection(requestUrl, shouldMorphMain = false) {
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    fetch(requestUrl, { signal: this.#abortController.signal })
      .then((res) => res.text())
      .then((text) => {
        this.#pendingRequestUrl = undefined;

        const html = new DOMParser().parseFromString(text, 'text/html');

        const newVariantPicker = html.querySelector(
          this.tagName.toLowerCase()
        );

        if (!newVariantPicker) return;

        const isFirstLoad = !this.#hydrated;

        if (shouldMorphMain && !isFirstLoad) {
          this.updateMain(html);
          return;
        }

        this.safeReplace(newVariantPicker);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') console.error(err);
      });
  }

  // =========================
  // 🔥 FIX: NO MORPH (ROOT CAUSE FIX)
  // =========================

  safeReplace(newNode) {
    // 💥 الحل الحقيقي: replace بدل morph (يمنع التكرار نهائيًا)
    this.replaceWith(newNode.cloneNode(true));
  }

  updateMain(newHtml) {
    const main = document.querySelector('main');
    const newMain = newHtml.querySelector('main');

    if (!main || !newMain) return;

    main.replaceWith(newMain.cloneNode(true));
  }

  // =========================

  get selectedOptionsValues() {
    const selected = this.querySelectorAll(
      'fieldset input:checked, select option[selected]'
    );

    return Array.from(selected).map(
      (el) => el.dataset.optionValueId
    );
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}